<template>
    <div>
        <!-- Stat Cards -->
        <v-row class="mb-4">
            <v-col cols="12" sm="6" md="3">
                <v-card color="indigo-darken-1" variant="flat" class="text-center">
                    <v-card-text class="pt-3">
                        <div class="text-caption mb-1" style="opacity:0.8">TOTAL TESTED</div>
                        <v-skeleton-loader v-if="loading" type="avatar" color="transparent"></v-skeleton-loader>
                        <h2 v-else>{{ stats ? stats.totalAttempts : '—' }}</h2>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card color="teal-darken-1" variant="flat" class="text-center">
                    <v-card-text class="pt-3">
                        <div class="text-caption mb-1" style="opacity:0.8">COMPLETED</div>
                        <v-skeleton-loader v-if="loading" type="avatar" color="transparent"></v-skeleton-loader>
                        <h2 v-else>{{ stats ? stats.completedAttempts : '—' }}</h2>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card color="blue-darken-2" variant="flat" class="text-center">
                    <v-card-text class="pt-3">
                        <div class="text-caption mb-1" style="opacity:0.8">AVERAGE SCORE</div>
                        <v-skeleton-loader v-if="loading" type="avatar" color="transparent"></v-skeleton-loader>
                        <h2 v-else>
                            {{ stats && stats.averageScorePercent != null ? stats.averageScorePercent + '%' : '—' }}
                        </h2>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <v-card color="blue-grey-darken-1" variant="flat" class="text-center">
                    <v-card-text class="pt-3">
                        <div class="text-caption mb-1" style="opacity:0.8">AVG TIME TAKEN</div>
                        <v-skeleton-loader v-if="loading" type="avatar" color="transparent"></v-skeleton-loader>
                        <h2 v-else>
                            {{ stats && stats.averageTimeTakenSeconds != null ? formatTime(stats.averageTimeTakenSeconds) : '—' }}
                        </h2>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <div v-if="!loading && stats && stats.completedAttempts === 0" class="text-center text-medium-emphasis pa-4">
            No completed attempts yet. Stats will appear once employees finish the quiz.
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'QuizDashboardPanel',
    props: {
        object: Object,
        entity: Object
    },
    data() {
        return {
            loading: false,
            stats: null,
            questionHeaders: [
                { title: 'Question', key: 'questionName' },
                { title: 'Correct Rate', key: 'correctPercent' },
                { title: 'Avg Time', key: 'avgTimeSeconds' },
                { title: 'Answered', key: 'totalAnswered' }
            ]
        };
    },
    mounted() {
        this.loadStats();
    },
    watch: {
        'object.id': function () { this.loadStats(); }
    },
    methods: {
        loadStats() {
            if (!this.quizId) return;
            this.loading = true;
            this.$api.get(`quiz/${this.quizId}/stats`)
                .then(res => { this.stats = res.data; })
                .catch(() => this.$store.dispatch('showErrorSnack', 'Failed to load quiz stats'))
                .finally(() => { this.loading = false; });
        },
        formatTime(seconds) {
            const m = Math.floor(seconds / 60);
            const s = seconds % 60;
            return m > 0 ? `${m}m ${s}s` : `${s}s`;
        },
        difficultyColor(percent) {
            if (percent >= 75) return 'success';
            if (percent >= 50) return 'warning';
            return 'error';
        }
    },
    computed: {
        ...mapState({
            entityRecord: state => state.entities.entityRecord
        }),
        quizId() {
            return this.object?.id ?? this.entityRecord?.id;
        }
    }
};
</script>
